module.exports = __webpack_public_path__ + "static/img/solution-1.946a2ab7.png";